export default __webpack_public_path__ + "static/media/condemn.ab21a1af.png";